import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FilterBase } from '../filter-base';
import { Filter } from '../filter';
import { GlobalFilterColor, GlobalFilterProperty } from '../../global-filters-types.enum';

@Component({
    selector: 'app-join-filter',
    templateUrl: './join-filter.component.html',
    styleUrls: ['./join-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: FilterBase, useExisting: JoinFilterComponent }],
})
export class JoinFilterComponent extends FilterBase {
    public joinFilterControl = new FormControl('or');
    @Output() filterChange: EventEmitter<Filter<string>> = new EventEmitter<Filter<string>>();
    @Output() filterRemoval: EventEmitter<Filter<string>> = new EventEmitter<Filter<string>>();
    protected _filter: Filter<string> = {
        property: GlobalFilterProperty.JOIN_TYPE,
        items: [],
        label: null,
        icon: 'manage_accounts',
        color: { bg: GlobalFilterColor.C4, fg: GlobalFilterColor.C1 },
        filterResultsChipStyleClass: 'global-join-event-filter-chip',
    };
    constructor() {
        super();
    }

    onSelectionChanged(value: string) {
        this.filter.items = [value];
        this.filterChange.emit(this.filter);
        this.joinFilterControl.setValue(value, { emitEvent: false });
    }
    clear(withFilterRemoval?: boolean): void {
        this.joinFilterControl.setValue('or');
        this.filter.items = null;
        if (withFilterRemoval) {
            this.filterRemoval.emit(this.filter);
        }
    }

    public get filter(): Filter<string> {
        return <Filter<string>>this._filter;
    }
    protected setFilterItems(items: any) {
        if (!items.length) return;
        this.joinFilterControl.setValue(items[0], { emitEvent: false });
        this.filter.items = items;
    }
}
